import { Button } from "@mui/material";

export default function CampaignActions({ campaign, perms, busy, onRefresh, onStart, onPause }) {
  const running = campaign.status === "ACTIVE";
  const ended = campaign.status === "ARCHIVED" || campaign.status === "DELETED";
  return (
    <div className="flex flex-wrap items-center gap-1">
      {perms.canRead ? (
        <Button size="small" disabled={busy} onClick={() => onRefresh(campaign)}>
          Refresh
        </Button>
      ) : null}
      {perms.canManage && !running && !ended ? (
        <Button
          size="small"
          variant="contained"
          color="primary"
          disabled={busy}
          onClick={() => onStart(campaign)}
        >
          Start
        </Button>
      ) : null}
      {perms.canManage && running ? (
        <Button size="small" variant="outlined" disabled={busy} onClick={() => onPause(campaign)}>
          Pause
        </Button>
      ) : null}
    </div>
  );
}
